import { Injectable } from '@angular/core';
import { deserializeImageAsset } from '@studio/data/deserialization/asset';
import { CREATE_IMAGE_ASSET } from '@studio/data/graphql';
import { ImageLibraryAsset, ZImageLibraryAsset } from '@studio/domain/creativeset/image-asset';
import { IMediaAsset } from '@studio/domain/element-asset';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

export type ImageCreationOptions = {
    name: string;
    fileSize: number;
    original: IMediaAsset;
    thumbnail: IMediaAsset;
};

@Injectable({ providedIn: 'root' })
export class ImageAssetService {
    constructor(private apollo: Apollo) {}

    createImage(image: ImageCreationOptions): Observable<ImageLibraryAsset> {
        return this.apollo
            .mutate({
                mutation: CREATE_IMAGE_ASSET,
                variables: {
                    image
                }
            })
            .pipe(
                map(({ data }) =>
                    ZImageLibraryAsset.parse(deserializeImageAsset(data!.createImageAsset))
                )
            );
    }
}
